module.exports = __webpack_public_path__ + "img/mbus.b149647c.png";